import Landing from "@/features/website/landing/Landing";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_website/")({
	component: Landing,
});
